import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { useMprcTheme } from "../MprcThemeProvider";

export const ButtonApplyFilter: React.FC<MprcButtonProps> = ({ text, title, ...rest }) => {
    const { theme } = useMprcTheme();
    const lText = text || theme.buttons.ButtonApplyFilter.text;
    const lTitle = title || theme.buttons.ButtonApplyFilter.title;

    return (
        <MprcButton
            {...rest}
            title={lTitle}
            text={lText}
        />
    );
};
